import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            网址分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            十大精选分类，覆盖日常上网全场景，快速定位您需要的网站
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 hover:bg-primary-50 rounded-lg p-5 text-center transition-all duration-300 cursor-pointer border border-background-200/70 hover:border-primary-200"
            >
              <span className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-background-50 rounded-lg group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-500`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap font-heading">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}